<section>
  <h1>{{'companyUserAssociation.titleUsers'|translate}}</h1>
  <div *ngIf="okMess" class="alert alert-success action-feedback">{{ okMess }}</div>
  <div *ngIf="!isLoading; else spinner">
    <ng-container *ngIf="dataSource && dataSource.data.length > 0; else noData">
      <div>
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="userName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Utilisateur</th>
            <td mat-cell *matCellDef="let row" class="main">{{ row.userName }}</td>
          </ng-container>
          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Role</th>
            <td mat-cell *matCellDef="let row">{{ row.role }}</td>
          </ng-container>
          <ng-container matColumnDef="isMain">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Agence principale</th>
            <td mat-cell *matCellDef="let row">{{ row.isMain | booleanFormat }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button appTooltip="Supprimer l'utilisateur"
                (click)="confirmDeleteUser(row.user)"><mat-icon color="primary">delete_forever</mat-icon></button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </ng-container>
    <ng-template #noData>
      <span class="no-content">Aucun utilisateur n'est associé à ce partenaire</span>
    </ng-template>
  </div>
</section>

<section>
  <h1>{{'companyUserAssociation.titleUserAdd'|translate}}</h1>
  <form [formGroup]="form" class="wrap">
    <div class="dialog-actions">
      <div class="form-group row">
        <app-input [label]="'input.user'" [formControl]="form_user" [autocompletionType]="'users'" [size]="4"
          [autocompletionExcludeIdList]="autocompletionExcludeIds" [disableUsersWithCompany]="false"></app-input>
        <app-select [label]="'userCompanyRole'" [formControl]="form_role" [list]="roleList" [isEnum]="true"
          enumName="UserCompanyRole" [isMultiple]="false" [size]="4"></app-select>
        <mat-checkbox class="col-md-4" [formControl]="form_main">{{'userCompanyMain' | translate}}
        </mat-checkbox>
      </div>
      <div class="form-group d-flex justify-content-end">
        <button mat-flat-button class="m-2" color="primary" [appTooltip]="'companyUserAssociation.add' | translate"
          (click)="onAddUser()">
          {{ 'companyUserAssociation.add' | translate }}
        </button>
      </div>
    </div>
  </form>
</section>

<ng-template #spinner>
  <p class="wrap-spinner">
    <mat-spinner [diameter]="20"></mat-spinner>
  </p>
</ng-template>